import React, { useState } from 'react';
import CloseIcon from "../../../Images//cancelicon.svg"
import ForgetEmail from "../../../Images/ForgetEmail.svg";

import Forgetphone from "../../../Images/phone.svg";
import config from '../../../config';
import { useNavigate } from 'react-router-dom';


function ForgetPasswordPopup({ onClose }) {
    const [email, setEmail] = useState('');
    const [mobileNo, setMobileNo] = useState('');
    const [emailError, setEmailError] = useState('');
    const [mobileNoError, setMobileNoError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showSuccessPopup, setShowSuccessPopup] = useState(false)
    const navigate = useNavigate()

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const validateMobileNo = (mobileNo) => {
        const mobileRegex = /^[0-9]{10}$/;
        return mobileRegex.test(mobileNo);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let isValid = true;

        if (!email && !mobileNo) {
            setEmailError('Please enter the registered e-mail ID OR Phone Number');
            setMobileNoError('Please enter the registered e-mail ID OR Phone Number');
            isValid = false;
        } else {
            setEmailError('');
            setMobileNoError('');
        }

        if (email && !validateEmail(email)) {
            setEmailError('Please enter a valid e-mail ID');
            isValid = false;
        } else {
            setEmailError('');
        }

        if (mobileNo && !validateMobileNo(mobileNo)) {
            setMobileNoError('Please enter a valid Phone Number');
            isValid = false;
        } else {
            setMobileNoError('');
        }

        if (isValid) {
            setIsLoading(true);
            try {
                // Simulate form submission logic here
                if (email) {
                    // Add your API call or logic here
                    const response = await fetch(`${config.api.API_URL}/api/emailcheck`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            email: email || null,
                            loginFrom: localStorage.getItem("LOGIN_DEVICE"),
                        }),
                    });

                    if (!response.ok) {
                        throw new Error('Failed to check email');
                    }

                    const result = await response.json();
                    if (result?.data?.status === "FAILURE") {
                        setEmailError(result?.data?.statusmsg);
                    } else {
                        setShowSuccessPopup(true)
                    }
                } else {
                    // Add your API call or logic here
                    const response = await fetch(`${config.api.API_URL}/api/phonecheck`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            mobileNumber: mobileNo || null,
                            loginFrom: localStorage.getItem("LOGIN_DEVICE"),
                        }),
                    });


                    const result = await response.json();
                    if (result?.data?.status === "FAILURE") {
                        setMobileNoError(result?.data?.statusmsg);
                    } else {
                        setShowSuccessPopup(true)
                        setTimeout(function () {
                            localStorage.setItem("LOGIN_ID", result?.data?.userId)
                            sessionStorage.setItem("otpnumber", mobileNo)
                            navigate("/getOTP")
                        }, 1000);
                    }
                }


            } finally {
                setIsLoading(false);
            }
        }
    };

    return (
        <>
            {showSuccessPopup ? <div className="popup-modal">
                <div className="popup-modal-content">
                    <p class=" forget-popup-header">
                        {email != "" ?
                            "Check your e-mail"
                            :
                            "Check your Mobile"
                        }
                    </p>
                    <div class="forget-popup-body">
                        <p data-success-type="" style={{ marginTop: "1rem", marginBottom: "4rem" }} class="forget-popup-success-msg">
                            {email ?"We have sent a OTP to the registered mobile number to reset your password" :"We have sent a link to the registered e-mail ID to reset your password"}
                        </p>
                        <div class="flex-center">
                            {email ? <img alt="" class="forget-popup-success-img" src={ForgetEmail} /> : <img alt="" class="forget-popup-success-img" src={Forgetphone} />}
                        </div>
                        <div onClick={onClose} style={{ marginTop: "2rem" }} class="flex-center">
                            <div id="forget-popup-success-close" class="btn-primary">OK</div>
                        </div>
                    </div>
                </div>
            </div>
                : <div className="popup-modal">
                    <div className="popup-modal-content">
                        <div className='popup-model-header'>
                            <p className="trouble-sigingIn">Having trouble signing in?</p>
                        </div>
                        <button type="button" className='popup-close-icon' onClick={onClose} disabled={isLoading}>
                            <img className="familyclose-btn-width cursor-pointer" src={CloseIcon} alt="" />
                        </button>
                        <form style={{ width: "80%", margin: "auto" }} id="forgetPasswordForm" onSubmit={handleSubmit}>
                            <p className="mail-text">Reset Password Using Mail ID</p>
                            <input
                                id="forgetEmail"
                                type="text"
                                name="email"
                                className="email-input"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                disabled={isLoading}
                            />
                            <div className="error forgetEmailError">{emailError}</div>
                            <div className="ordiv">
                                <div className="Orround">OR</div>
                            </div>
                            <div className="">
                                <p className="password-phone-text">
                                    Reset Password Using Phone Number
                                </p>
                                <div style={{ display: "flex" }}>
                                    <input
                                        id="forgetIsd"
                                        disabled
                                        name="isdCode"
                                        type="text"
                                        className="isdCodeInput"
                                        value="+91"
                                    />
                                    <input
                                        id="forgetMobileNumber"
                                        type="text"
                                        name="mobileNo"
                                        style={{ flex: 1, marginLeft: "1rem" }}
                                        className="numberInput"
                                        placeholder="Mobile No"
                                        value={mobileNo}
                                        onChange={(e) => setMobileNo(e.target.value)}
                                        disabled={isLoading}
                                    />
                                </div>
                                <div className="error forgetMobileNumberError">{mobileNoError}</div>
                            </div>
                            <div className="div1"></div>
                            <div className="submitbtndiv">
                                <button type="submit" className="continueBtn" disabled={isLoading}>
                                    {isLoading ? 'Loading...' : 'Continue'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>}

        </>
    );
}

export default ForgetPasswordPopup